import { Product } from '../../../interfaces/domain/menu';
import { formatPrice } from '../../../utils/formatersPrecio';
import styles from './PricePlate.module.scss';

interface PricePlateProps {
  plate: Product;
  priceClassName?: string;
}

export const PricePlate = ({
  plate,
  priceClassName = "",
}: PricePlateProps) => {
  if (!plate) return null;
  const isSuper =
    plate.tags?.includes("superdestacado") ?? false;

  const hasOptions =
    !!(plate.options && plate.options.length > 0);

  return (
    <div
      className={`
        ${
          isSuper
            ? styles.containerSuperPriceQuantity
            : styles.containerPriceQuantity
        }
      `}
    >
      {hasOptions ? (
        <div className={styles.containerOptionNamePrice}>
          <span className={styles.optionName}>
            {plate.options[0].name}
          </span>

          <span  className={`${styles.optionPrice} ${priceClassName}`} >
            {formatPrice(
              plate.options[0].items[0]?.price ?? 0
            )}
          </span>
        </div>
      ) : (
        <span  className={`${styles.price} ${priceClassName}`} >
          {formatPrice(plate.price, {
            emptyLabel: "Consultar",
          })}
        </span>
      )}
    </div>
  );
};